import React, { useState, useEffect } from 'react';
import { useContextoSesion } from '../../miscelaneo/ContextoSesion';
import instanciaAxios from '../../miscelaneo/instanciaAxios';
import FuncionesGenerales from '../util/FuncionesGenerales';
import TarjetaMetrica from './TarjetaMetrica';
import BusquedaRapida from './BusquedaRapida';
import GraficoVentasMes from './GraficoVentasMes';
import SeccionAlertas from './SeccionAlertas';
import ActividadReciente from './ActividadReciente';

const SkeletonCard = () => (
  <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 animate-pulse">
    <div className="flex items-center gap-3 mb-3">
      <div className="w-10 h-10 bg-gray-200 rounded-lg" />
      <div className="h-4 w-24 bg-gray-200 rounded" />
    </div>
    <div className="h-7 w-32 bg-gray-200 rounded mb-3" />
    <div className="h-3 w-20 bg-gray-200 rounded" />
  </div>
);

const SkeletonBlock = ({ className = '' }) => (
  <div className={`bg-white rounded-xl border border-gray-200 shadow-sm p-5 animate-pulse ${className}`}>
    <div className="h-4 w-40 bg-gray-200 rounded mb-6" />
    <div className="space-y-3">
      {[1, 2, 3].map(i => (
        <div key={i} className="h-4 w-full bg-gray-200 rounded" />
      ))}
    </div>
  </div>
);

const Dashboard = () => {
  const { usuario } = useContextoSesion();
  const { formatoMoneda } = FuncionesGenerales(usuario);

  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargarDashboard = async () => {
      try {
        setCargando(true);
        const { data } = await instanciaAxios.get('/dashboard/resumen');
        setDatos(data);
      } catch (error) {
        console.error('Error al cargar dashboard:', error);
      } finally {
        setCargando(false);
      }
    };
    cargarDashboard();
  }, []);

  const saludo = () => {
    const hora = new Date().getHours();
    if (hora < 12) return 'Buenos días';
    if (hora < 18) return 'Buenas tardes';
    return 'Buenas noches';
  };

  return (
    <div className="space-y-5">
      {/* Header: Saludo + Búsqueda */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">
            {saludo()}, {usuario?.nombre || 'Usuario'}
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Aquí tienes un resumen de tu negocio
          </p>
        </div>
        <BusquedaRapida />
      </div>

      {/* Tarjetas KPI */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {cargando ? (
          <>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </>
        ) : (
          (datos?.metricas || []).map((metrica) => (
            <TarjetaMetrica
              key={metrica.id}
              titulo={metrica.titulo}
              monto={metrica.monto}
              porcentajeCambio={metrica.porcentajeCambio}
              tendencia={metrica.tendencia}
              icono={metrica.icono}
              formatoMoneda={formatoMoneda}
            />
          ))
        )}
      </div>

      {/* Contenido principal: Izquierda (Gráfico + Actividad) | Derecha (Alertas) */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        {/* Columna izquierda */}
        <div className="lg:col-span-3 flex flex-col gap-4">
          {cargando ? (
            <>
              <SkeletonBlock className="h-64" />
              <SkeletonBlock />
            </>
          ) : (
            <>
              <GraficoVentasMes datos={datos?.graficoVentas || []} />
              <div className="flex-1">
                <ActividadReciente
                  transacciones={datos?.actividadReciente || []}
                  formatoMoneda={formatoMoneda}
                />
              </div>
            </>
          )}
        </div>

        {/* Columna derecha - Alertas ocupa toda la altura */}
        <div className="lg:col-span-2 h-full">
          {cargando ? (
            <SkeletonBlock className="h-full" />
          ) : (
            <SeccionAlertas alertas={datos?.alertas || []} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
